import styled from 'styled-components';

import theme from '../../../theme';

export const Item = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid ${theme.colors.grayish_blue};

  &:last-child {
    border-bottom: none;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const Message = styled.div`
  white-space: pre-wrap;
  word-break: break-word;
`;

export { IconWrapper } from '../styles';
